<template>
  <div>
    <h1>&lt;tree-view /&gt; component</h1>

    <v-card class="ma-1">
      <v-card-title primary-title>
        <h3 class="headline">Tree with default properties - title, children</h3>
      </v-card-title>
      <tree-view :root="tree"/>
    </v-card>
    <v-card class="ma-1">
      <v-card-title primary-title>
        <h3 class="headline">Tree with custom properties</h3>
      </v-card-title>
      <tree-view :root="curriculum" :property-mapper="curriculumMapper"/>
    </v-card>
    <v-card class="ma-1">
      <v-card-title primary-title>
        <h3 class="headline">Tree with custom item-template</h3>
      </v-card-title>
      <tree-view
        :root="curriculum"
        :property-mapper="curriculumMapper"
        :item-template-str="template1"
      />
    </v-card>
    <v-card class="ma-1">
      <v-card-title primary-title>
        <h3 class="headline">Tree with custom component</h3>
      </v-card-title>
      <tree-view
        :root="curriculum"
        :property-mapper="curriculumMapper"
        :item-component="$options.components.CustomTreeViewItem"
      />
    </v-card>
    <v-card class="ma-1">
      <v-card-title primary-title>
        <h3 class="headline">Root bound to array</h3>
      </v-card-title>
      <tree-view :root="array"/>
    </v-card>

    <!--   <b-card class="m-1" header="Tree with different item-template">
            <tree-view :root="curriculum" :property-mapper="curriculumMapper" :item-template-str="template2" />
        </b-card>
       <b-card class="m-1" header="Tree with custom component">
            <tree-view :root="curriculum" :property-mapper="curriculumMapper"
                       :item-component="$options.components.CustomTreeViewItem" />
    </b-card>-->
  </div>
</template>

<script>
import TreeView from '@/ux/generic-components/TreeView.vue';
import CustomTreeViewItem from './CustomTreeViewItem.vue';

export default {
  name: 'tree-view-playground',
  components: { TreeView, CustomTreeViewItem },
  data() {
    return {
      array: [
        {
          title: 'Item 1',
          children: [{ title: 'Child 1' }, { title: 'child 2' }],
        },
        {
          title: 'Item 2',
          children: [{ title: 'Child 1' }, { title: 'child 2' }],
        },
        {
          title: 'Item 4',
          children: [{ title: 'Child 1' }, { title: 'child 2' }],
        },
        {
          title: 'Item 5',
          children: [{ title: 'Child 1' }, { title: 'child 2' }],
        },
        {
          title: 'Item 6',
          children: [{ title: 'Child 1' }, { title: 'child 2' }],
        },
      ],
      tree: {
        title: 'Level 0',
        children: [
          {
            title: 'Level1 (A)',
            children: [],
          },
          {
            title: 'Level1 (B)',
            children: [
              {
                title: 'Level2 (A)',
                children: [],
              },
              {
                title: 'Level2 (B)',
                children: [],
              },
            ],
          },
        ],
      },
      curriculum: {
        name: 'Curriculum',
        intentions: [
          {
            title: 'Intention 1',
            pos: [],
          },
          {
            title: 'Intention 2',
            pos: [
              {
                code: 'Pos 1',
                description: 'Program of study #1',
                children: [],
              },
              {
                code: 'Pos 2',
                description: 'Program of study #2',
                children: [],
              },
            ],
          },
        ],
      },
      template1: '<span >{{ item.title || item.name || item.code }}</span>',
      template2:
        '<span ><small>' +
        '{{ item.title || item.name || item.code }}</small></span>',
    };
  },
  methods: {
    curriculumMapper(node, prop) {
      let propName = null;
      switch (prop) {
        case 'title':
          if (node.intentions) {
            propName = 'name';
          } else if (node.pos) {
            propName = 'title';
          } else {
            propName = 'code';
          }
          break;
        case 'children':
          if (node.intentions) {
            propName = 'intentions';
          } else if (node.pos) {
            propName = 'pos';
          } else {
            propName = 'children';
          }
          break;
        default:
          throw new Error(`Unknown prop=${prop}`);
      }
      return propName;
    },
  },
};
</script>

<style scoped>
</style>
